<template>
  <div class="body-container">
    <div class="body-box">
      <div class="tabs">
        <div
          class="tab-item"
          @click="handleIndex(1)"
          :class="{ active: currentIndex == 1 }"
        >
          <img v-if="currentIndex != 1" src="../../assets/newImg/2.png" alt="" />
          <img v-if="currentIndex == 1" src="../../assets/newImg/2_active.png" alt="" />
          <div class="text">通知公告</div>
        </div>
      </div>
    </div>

    <div class="tabs-content" v-if="currentIndex == 1">
      <template v-if="newsList.length > 0">
        <div class="content-item" v-for="(item, index) in newsList" :key="index">
          <div class="info-box">
            <p>{{ item.title }}</p>
            <p>发布时间: {{ item.publishTime }}</p>
          </div>
          <router-link
            :to="{
              path: '/newsDetail',
              query: { id: item.id },
            }"
            class="button-info"
            >查看详情</router-link
          >
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          background
          style="
            display: flex;
            justify-content: center;
            algin-items: center;
            margin: 30px 0px;
          "
          layout="prev, pager, next, jumper"
          :total="total"
          :page-size="10"
          :current-page.sync="pageNum"
        >
        </el-pagination>
      </template>
      <div v-else style="width: 100%">
        <el-divider content-position="center">暂无数据</el-divider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 1,

      total: 0,
      pageNum: 1,
      categoryId: "",
      categoryName: "",
      title: "",
      newsList: [],
      categoryList: [],
    };
  },
  created() {
    if (this.$route.query.categoryId) {
      this.categoryId = this.$route.query.categoryId;
      this.getNewList();
      this.getCategoryList();
    }
  },
  watch: {
    $route(to) {
      this.categoryId = to.query.categoryId;
      if (this.$route.query.name) {
        this.title = this.$route.query.name;
      }
      this.getNewList();
      this.getCategoryList();
    },
  },
  methods: {
    handleIndex(val) {
      this.currentIndex = val;
    },
    // 分页 页面改变时发送的请求
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getNewList();
    },

    getCategoryList() {
      let _this = this;
      _this.$api.news
        .articleCategoryList()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.categoryList = res.data.filter((item) => item.id != 3);
          }
        })
        .catch(() => {});
    },
    selCategory(id) {
      this.categoryId = id;
      this.pageNum = 1;
      this.getNewList();
    },
    // 发送的是这个请求
    getNewList() {
      let _this = this;
      let parmas = {
        pageNum: _this.pageNum,
        pageSize: 10,
        categoryId: _this.categoryId,
      };
      _this.$api.news
        .articleList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.newsList = res.rows;
            _this.total = Number(res.total);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.el-divider__text.is-center {
  background-color: unset;
  font-size: 20px;
}
.body-container {
  background-color: rgba(164, 171, 189, 0.16);
  /* max-width: 1200px; */
  width: 100%;
  padding-bottom: 24px;
}
.body-container .body-box {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 0px;
}
.body-container .body-box .tabs {
  width: 100%;
  height: 56px;
  margin-top: 24px;

  border-bottom: 2px solid rgb(64, 112, 179);
  display: flex;
  align-items: center;
}
.body-container .tabs .tab-item {
  width: 13%;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.body-container .tabs .tab-item img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.body-container .tabs .tab-item .text {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
}
.body-container .tabs .tab-item.active {
  width: 13%;
  height: 100%;
  background-color: rgb(64, 112, 179);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255, 255, 255);
}
.body-container .tabs .tab-item.active .text {
  color: rgb(255, 255, 255);
}
.body-container .tabs-content {
  max-width: 1200px;
  margin: 0px auto;
}
.body-container .tabs-content .content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background-color: #fff;
  margin-bottom: 24px;
}
.body-container .tabs-content .content-item .info-box {
  width: 70%;
}
.body-container .tabs-content .content-item .info-box p:nth-child(1) {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.body-container .tabs-content .content-item .info-box p:nth-child(2) {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
}
.body-container .tabs-content .content-item .button-info {
  width: 144px;
  height: 40px;
  background: rgb(64, 112, 179);
  border-radius: 8px;
  text-align: center;
  color: rgb(255, 255, 255);
  font-family: PingFang SC;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/news/newsListInform.vue